/**
 * CRM module layout — Expense-style page + pill-tab bar across the top. The tabs
 * ARE the CRM subpages (no sidebar, no nested rail items). Each tab is gated by
 * the role authority that page requires, so e.g. a Read-only or Hotel-Supplier
 * user sees only the tabs their role allows. Renders inside CrmModuleShell
 * (.crm-scope + MeProvider); pages render in its <Outlet>.
 *
 * The tab list comes from the PAGE REGISTRY (features/admin/lib/page-registry),
 * not a local array — the same list the left rail filters on and the admin User
 * Management screen reports from. Add a CRM page there and it appears here, on
 * the rail, and in the admin page picker at once. Nothing about the gating
 * behaviour changed: the `capability` on each tab is the one that used to be
 * hard-coded in this file.
 */
import { moduleTabs } from '@/features/admin/lib/page-registry';
import type { Capability } from './auth/roles';
import { CrmModuleShell, type ModuleTab } from './CrmModuleShell';

const CRM_TABS: ModuleTab[] = moduleTabs<Capability>('crm');

export function CrmLayout() {
  return <CrmModuleShell title="Customer Management" tabs={CRM_TABS} />;
}
